import type { Chord } from 'svguitar';

export const FChords: Record<string, Chord> = {
  F: {
    fingers: [
      [3, 2, '1'],
      [4, 3, '3'],
      [5, 3, '2'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 1,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'F',
    position: 0,
  },
  Fm: {
    fingers: [
      [4, 3, '3'],
      [5, 3, '2'],
    ],
    barres: [
      {
        fromString: 6,
        toString: 1,
        fret: 1,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'Fm',
    position: 0,
  },
};
